import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IotaModalSize, MAT_DIALOG_DATA, MatDialogRef } from '@iota/iota-ui-components';
import { Store } from '@ngrx/store';
import {
    InitSmartDocumentUpload,
    ResetSmartDocumentUpload,
    SmartDocumentUploadAddFile,
    SmartDocumentUploadSubmit
} from 'src/app/store/actions/smart-document-upload.actions';
import {
    smartDocumentUploadApiCallError,
    smartDocumentUploadCurrentStep,
    smartDocumentUploadIsInResultStep,
    smartDocumentUploadIsInUploadStep,
    smartDocumentUploadLoading,
    smartDocumentUploadNumberOfUploadedFiles
} from 'src/app/store/reducer/smart-document-upload.reducer';
import { SmartDocumentUploadStepLabels } from '../../constants-and-enums/smart-document-upload-types';
import { SmartDocumentUploadFileUploadComponent } from './smart-document-upload-file-upload/smart-document-upload-file-upload.component';
import { HealthyWorkplaceSurveyManagementDTO } from '@iota/inh-core-v1-management-client';
import { CompanyMode } from '../../constants-and-enums/company-mode.enum';

export interface SmartDocumentUploadDialogData {
    mode: CompanyMode;
    entityId: string;
    businessPartnerNumber: string;
    isHwp?: boolean;
    hwp?: HealthyWorkplaceSurveyManagementDTO;
}

@Component({
    standalone: false,
    selector: 'app-smart-document-upload-dialog',
    templateUrl: './smart-document-upload-dialog.component.html',
    styleUrls: ['./smart-document-upload-dialog.component.scss']
})
export class SmartDocumentUploadDialogComponent implements OnInit, OnDestroy {
    @ViewChild('fileUploadComponent') fileUploadComponent: SmartDocumentUploadFileUploadComponent;
    public modalOptions = {
        size: IotaModalSize.SIZE_7XL
    };

    isInUploadStep$ = this.store.select(smartDocumentUploadIsInUploadStep);
    isInResultStep$ = this.store.select(smartDocumentUploadIsInResultStep);

    stepLabels = SmartDocumentUploadStepLabels;
    currentStep$ = this.store.select(smartDocumentUploadCurrentStep);

    loading$ = this.store.select(smartDocumentUploadLoading);
    numberOfUploadedFiles$ = this.store.select(smartDocumentUploadNumberOfUploadedFiles);
    apiError$ = this.store.select(smartDocumentUploadApiCallError);

    nextButtonDisabled = true;

    isFullScreen = false;
    isAnimating = false;

    constructor(
        private dialogRef: MatDialogRef<SmartDocumentUploadDialogComponent>,
        private store: Store,
        @Inject(MAT_DIALOG_DATA) public data: SmartDocumentUploadDialogData
    ) {}

    ngOnInit(): void {
        setTimeout(() => {
            this.isAnimating = true;
        }, 100);

        this.store.dispatch(InitSmartDocumentUpload());
    }

    setNextButtonDisabled(disabled: boolean) {
        this.nextButtonDisabled = disabled;
    }

    nextStep() {
        const fileData = this.fileUploadComponent.getFileData();
        this.store.dispatch(SmartDocumentUploadAddFile({ fileData }));
        this.fileUploadComponent.initializeFormAndResetFileInput();
    }

    submit() {
        this.nextStep();
        this.store.dispatch(
            SmartDocumentUploadSubmit({
                hwpId: this.data?.hwp?.id,
                mode: this.data?.mode,
                entityId: this.data?.entityId,
                businessPartnerNumber: this.data?.businessPartnerNumber
            })
        );
    }

    closeDialog() {
        this.isAnimating = false;
        this.store.dispatch(ResetSmartDocumentUpload());
        this.dialogRef.close();
    }

    ngOnDestroy(): void {
        this.isAnimating = false;
    }
}
